export default {
  minDateMessage: 'Merci de vérifier la date de naissance',
  maxDateMessage: 'Merci de vérifier la date de naissance',
  invalidDateMessage: 'Merci de vérifier la date de naissance',
  invalidLabel: "Le format de la date n'est pas valide",
  cancelLabel: 'Annuler',
  clearLabel: 'Effacer',
  todayLabel: "Aujourd'hui",
};
